module.exports = __webpack_public_path__ + "images/2469460d3e9c9ea918e236e80a32071b.png";


//////////////////
// WEBPACK FOOTER
// ./js/components/assets/man/7.png
// module id = 367
// module chunks = 0